import {combineEpics, Epic} from 'redux-observable';
import {fetchPropertiesAction, propertiesResponseAction} from 'module/Properties/action/PropertiesAction';
import {EMPTY, from, of} from 'rxjs';
import {catchError, filter, map, mergeMap, switchMap, take} from 'rxjs/operators';
import Property, {fetchProperties} from 'collection/PropertyCollection';
import {PropLog} from 'module/Properties/selector/selPropGen';
import {appInitAction} from 'util/ReduxUtil';
import _ from 'lodash';
import {alertServerError} from 'module/ConfirmDialog/component/ConfirmDialogContainer'
import {parseServerError} from 'module/Error/util/parseServerError'

const initEpic: Epic = action$ => action$.pipe(
	filter(appInitAction.match),
	take(1),
	switchMap(({payload: {properties}}) =>
		!_.isEmpty(properties) ? of(fetchPropertiesAction(properties)) : EMPTY,
	),
);

const fetchEpic: Epic = action$ => action$.pipe(
	filter(fetchPropertiesAction.match),
	mergeMap(({payload}) => {
			const req = fetchProperties(...payload)
			return from(Promise.resolve(req)).pipe(
				map(() => {
					PropLog.unfetchedUse = true // first fetch is done. Warn of unfetch usage.
					return propertiesResponseAction(
						payload.map((propId) => Property._inst.get(propId.toString()).toJSON()),
					)
				}),
				catchError((err: any) => {
					void alertServerError('Error fetching Properties', parseServerError(err))
					return []
				}),
			)
		},
	),
);

export const PropertiesEpic = combineEpics(initEpic, fetchEpic);